/* Reformly Home — "Backed by science" study overlay.

   Almost nothing, on purpose. The markup uses a native <dialog>, so the focus
   trap, Escape, inertness of the page behind and the ::backdrop scrim are the
   platform's job. This file only decides when to call showModal(), and closes
   on a click outside the panel — the one behaviour <dialog> does not give you,
   because the backdrop is painted by the dialog itself and a click on it
   targets the dialog.

   "Learn more" stays a real <a href>. preventDefault is called only after a
   dialog has actually been found, so without JS, or if a card has no overlay
   configured, the link still goes to its source.
*/
(function () {
  var triggers = document.querySelectorAll('[data-rhm-sci-open]');
  if (!triggers.length) return;

  /* Older Safari and any browser without showModal() keeps the plain link. */
  var supported = typeof HTMLDialogElement === 'function' &&
    typeof HTMLDialogElement.prototype.showModal === 'function';
  if (!supported) return;

  Array.prototype.forEach.call(triggers, function (trigger) {
    var dialog = document.getElementById(trigger.getAttribute('data-rhm-sci-open'));
    if (!dialog) return;

    trigger.addEventListener('click', function (e) {
      /* Let modified clicks through: cmd/ctrl-click and middle-click should
         still open the study in a new tab rather than be swallowed. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      dialog.showModal();

      /* Move focus to the DIALOG, not the close button.

         showModal() otherwise focuses the first focusable descendant, which is
         the X, and the browser counts that as keyboard focus — so the theme's
         `*:focus-visible` rule paints a 2px grey outline at a 3px offset,
         drawing a ring around the icon. On a phone it lands the moment you
         tap, so it reads as a stuck touch state.

         `tabindex="-1"` on the dialog (set in the section) is what makes this
         call possible; the attribute alone is not enough, because Chrome still
         prefers a focusable descendant unless told otherwise.

         Nothing is lost: the modal still traps focus, Escape still closes, the
         aria-label is still announced, and the first Tab moves to the close
         button — where a ring is correct, because that IS keyboard use. */
      if (typeof dialog.focus === 'function') dialog.focus();
    });

    Array.prototype.forEach.call(dialog.querySelectorAll('[data-rhm-sci-close]'), function (btn) {
      btn.addEventListener('click', function () { dialog.close(); });
    });

    /* Click outside the panel. A click on the backdrop has the DIALOG as its
       target, since the backdrop belongs to it — so "target is the dialog
       itself" is exactly "not inside the panel". Checking the point against
       the dialog's box as well, because a click on the dialog's own padding
       would otherwise read the same way. */
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      var outside = e.clientX < r.left || e.clientX > r.right ||
                    e.clientY < r.top || e.clientY > r.bottom;
      if (outside) dialog.close();
    });
  });
})();
